import Vue from 'vue';
import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || process.env.apiUrl || '';

// Remove this if present (forces urlencoded):
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const _axios = axios.create({
    // Optional: you can enforce JSON explicitly, but not required
    // headers: { 'Content-Type': 'application/json' },
});

_axios.interceptors.request.use((config) => config, (error) => Promise.reject(error));
_axios.interceptors.response.use((res) => res, (error) => Promise.reject(error));

const Plugin = {};
Plugin.install = function (Vue) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: { get() { return _axios; } },
        $axios: { get() { return _axios; } },
    });
};

Vue.use(Plugin);
export default Plugin;
